<template>
  <v-dialog :value="dialog" persistent  max-width="460" transition="fade">
    <v-card>
      <v-card-title class="headline"></v-card-title>

      <v-card-text v-if="userProfile">

        <div class="schedule-confirmation-dialog-text mx-5" v-if="!less_than_24 && ( userProfile.user.cancel_count >= 3 || userProfile.user.cancel_count <= 3 )">
          <b>TEM CERTEZA QUE DESEJA<BR />DESMARCAR ESTA AULA?</b>
          <br /><br />
          <v-icon>mdi-information-outline</v-icon>
          <br />Você já desmarcou {{ (userProfile.user.cancel_count + 0) }} aula neste semestre, ainda pode desmarcar 
          {{ quantityCanceled }} (sem perder o crédito da aula).
          <br />
        </div> 
        
        <div class="schedule-confirmation-dialog-text mx-5" v-if="less_than_24">
          <b>TEM CERTEZA QUE DESEJA<BR />DESMARCAR ESTA AULA?</b>
          <br /><br />
          <v-icon>mdi-information-outline</v-icon>
          <br />

          <p> <strong style="color:#FF3d00"> Você não receberá seu crédito de volta </strong> pois sua aula começaria dentro de 24h. </p>
          <br />
        </div>


        <div class="text-center">
          <v-btn
          @click="confirmUnschedule"
          color="#FF3d00"
          class="px-5 mt-3 mb-12"
          rounded
          :loading="loading"
          depressed
          outlined
        >
          Desmarcar aula
        </v-btn>
        <br/>

        <v-btn
          color="primary"
          class="px-5 mt-5"
          rounded
          depressed
          @click="$emit('negative')"
        >
          Voltar
        </v-btn>
        </div>
      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
import DialogMixin from "@/mixins/dialogs/DialogMixin";
import StudentsRepository from "@/repositories/StudentsRepository";

import { mapState } from 'vuex'

export default {
  mixins: [DialogMixin],
  data() {
    return {
      defaultForm: undefined,
      loading: false,
      less_than_24: false,

    };
  },

  props: {
    classData: Object,
    fromTeacher: Boolean
  },

  computed: {
    ...mapState(['userProfile']),

    quantityCanceled() {
      if (this.userProfile.user.cancel_count <= 3 ) {
        return -1 * (this.userProfile.user.cancel_count - 3)

      } else {
        return 0
      }
    }
  },

  methods: {
    confirmUnschedule() {
      this.loading = true;
      this.$emit('positive')
    }
  },


  async mounted () {
    console.log( '+++++++++++' )
    console.log( this.userProfile )
    console.log( '+++++++++++' )

    let response = {}
    response = await StudentsRepository.verify_24_class(this.classData.id)

    if ( response.data.less_than_24 ) {
      this.less_than_24 = true
    }

  }
}
</script>

  <style>

.schedule-confirmation-dialog-text {
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: rgba(45, 35, 58, 0.5);
  line-height: 1.4;
}
.schedule-confirmation-dialog-text span {
  font-size: 21px;
  font-weight: 900;
  color: #440099;
  text-transform: uppercase;
}
</style>